import { AppKeycloakGuard } from './guard/app.keycloakguard';
import { GuardFactory } from './guard/app.guard.factory';
import { MainGuard } from './guard/app.main.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuard } from './guard/app.authguard';

// ROUTING
export const AppRoutes = {
  MAIN: 'main',
  DASHBOARD: 'main/dashboard',
  WIZARD: 'main/wizard',
  SETTINGS: 'main/acc_settings',
  ERROR: 'error',
  IMPRINT: 'main/imprint',
  PRIVACY: 'main/privacy',
  PROFILE: 'main/profile',
  PUBLIC: 'public',
  FAQ: 'main/faq',
  MEDIA: 'main/media',
  REVIEWS: 'main/review',
  DIRECTORIES: 'main/directories',
};

const Paths: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: 'main', canActivate: [MainGuard], loadChildren: () => import('./main/main.module').then(m => m.MainModule) },
  { path: 'scan', loadChildren: () => import('./scan/scan.module').then(m => m.ScanModule) },
  { path: 'version', loadChildren: () => import('./version/version.module').then(m => m.VersionModule) },
  { path: '**', redirectTo: 'main' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(Paths, {
      useHash: true,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [MainGuard, AppAuthGuard, GuardFactory, AppKeycloakGuard],
})
export class AppRoutingModule {}
